import { render, staticRenderFns } from "./_base-layout.vue?vue&type=template&id=0a2c8c2a&"
import script from "./_base-layout.vue?vue&type=script&lang=ts&"
export * from "./_base-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports